const KILOGRAMS_PER_TON = 1000;
const FRACTION_DIGITS = 2;
// a no-break space keeps the unit on the same line as its amount
const UNIT_SEPARATOR = ' ';

// The models carry kilograms, front to back. Reading a footprint in tons is a view decision, so the
// conversion and its unit live here alone and nowhere else. Whatever the unit, the amount is rounded
// to two decimals.
export const useCarbonEmissionFormat = (carbonEmissionInKilograms?: number) => {
  // nothing to measure carries no unit — and 0 kg is how the BFF says "no carbon data"
  if (!carbonEmissionInKilograms) {
    return useAmountFormat(carbonEmissionInKilograms);
  }

  // under a ton, "0.18 t" reads worse than "182.00 kg" — the kilograms stay as they are
  const [amount, unit] =
    carbonEmissionInKilograms < KILOGRAMS_PER_TON
      ? [carbonEmissionInKilograms, 'kg']
      : [carbonEmissionInKilograms / KILOGRAMS_PER_TON, 't'];

  return `${useAmountFormat(amount, FRACTION_DIGITS, FRACTION_DIGITS)}${UNIT_SEPARATOR}${unit}`;
};
